import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import * as React from 'react';

var WeekPanel = function (_React$PureComponent) {
    _inherits(WeekPanel, _React$PureComponent);

    function WeekPanel() {
        _classCallCheck(this, WeekPanel);

        return _possibleConstructorReturn(this, (WeekPanel.__proto__ || Object.getPrototypeOf(WeekPanel)).apply(this, arguments));
    }

    _createClass(WeekPanel, [{
        key: "render",
        value: function render() {
            return React.createElement(
                "div",
                { className: "week-panel" },
                React.createElement(
                    "div",
                    { className: "cell cell-grey" },
                    "\u65E5"
                ),
                React.createElement(
                    "div",
                    { className: "cell" },
                    "\u4E00"
                ),
                React.createElement(
                    "div",
                    { className: "cell" },
                    "\u4E8C"
                ),
                React.createElement(
                    "div",
                    { className: "cell" },
                    "\u4E09"
                ),
                React.createElement(
                    "div",
                    { className: "cell" },
                    "\u56DB"
                ),
                React.createElement(
                    "div",
                    { className: "cell" },
                    "\u4E94"
                ),
                React.createElement(
                    "div",
                    { className: "cell cell-grey" },
                    "\u516D"
                )
            );
        }
    }]);

    return WeekPanel;
}(React.PureComponent);

export default WeekPanel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-calendar/es/date/WeekPanel.js
// module id = null
// module chunks = 